<template>
    <!--
    <div class="footer-panel container">
        <div :class="`d-block d-md-flex justify-content-between ${isMobile? 'mb-3' : ''}`">
            <div>
                <p>Quality Group Soc. Cons. a.r.l. - Lungo Dora P. Colletta 67, 10153 Torino<br/>
                    P. Iva 08639130015 - Capitale sociale: €. 10.000 i.v. - Iscritta al Reg. Imprese di Torino al n. 08639130015
                </p>
            </div>
            <div>
                <ul class="nav">
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.qualitygroup.it/docs/cookie.pdf" target="_blank">Cookie policy</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="https://www.qualitygroup.it/docs/privacy.pdf" target="_blank">Privacy policy</a>
                    </li>
                </ul>
            </div>
        </div>
        <cookie-law theme="dark-lime" button-text="Accetto">
            <div slot="message">
                Questo sito fa uso di cookie per migliorare l’esperienza di navigazione degli utenti e per raccogliere informazioni sull’utilizzo del sito stesso.<br>
                Chiudendo questo banner o proseguendo nella navigazione se ne accetta l’uso illustrato nella nostra cookie policy.<br>
                <a href="http://www.qualitygroup.it/docs/cookie.pdf" target="_blank">La politica dei Cookie</a>
            </div>
        </cookie-law>
    </div>
    -->
    <CustomFooter class="footer-panel container"/>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import MobileDetector from '../../../common/MobileDetector'

export default {
  name: 'Footer',
  mixins: [MobileDetector],
  components: { CookieLaw }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/common/Footer.vue